// components/admin/AdminNavbar.js
import React, { useEffect, useState } from "react";
import { Navbar, Container, Dropdown, Badge } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import {
  Bell,
  Envelope,
  PersonCircle,
  Search,
  Gear,
} from "react-bootstrap-icons";
import { useLocation, useNavigate } from "react-router-dom";

const AdminNavbar = () => {
  const { adminData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (location.pathname.startsWith("/admin/search")) {
      const params = new URLSearchParams(location.search);
      setSearchTerm(params.get("q") || "");
    } else {
      setSearchTerm("");
    }
  }, [location]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const term = searchTerm.trim();
    if (!term) return;
    navigate(`/admin/search?q=${encodeURIComponent(term)}`);
  };

  const displayName =
    adminData?.fullName || adminData?.username || "Admin User";
  const displayRole =
    adminData?.role === "super_admin"
      ? "Super Admin"
      : adminData?.role || "Admin";

  return (
    <Navbar
      bg="white"
      variant="light"
      className="shadow-sm border-bottom"
      style={{ height: "70px" }}
    >
      <Container fluid className="px-4">
        {/* Search Bar */}
        <div className="d-flex align-items-center w-50">
          <form className="w-100" onSubmit={handleSearchSubmit}>
            <div className="input-group" style={{ maxWidth: "400px" }}>
              <span className="input-group-text bg-transparent border-end-0">
                <Search size={18} />
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Search students, questions, appointments..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  backgroundColor: "#f8fafc",
                  borderColor: "#e2e8f0",
                }}
              />
            </div>
          </form>
        </div>

        {/* Right Side Icons */}
        <div className="d-flex align-items-center gap-3">
          {/* User Profile */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="light"
              className="d-flex align-items-center gap-2 border-0"
            >
              <div className="bg-primary rounded-circle p-2">
                <PersonCircle size={30} className="text-white" />
              </div>
              <div className="d-none d-md-block">
                <div className="fw-medium">{displayName}</div>
                <small className="text-muted">{displayRole}</small>
              </div>
            </Dropdown.Toggle>
          </Dropdown>
        </div>
      </Container>
    </Navbar>
  );
};

export default AdminNavbar;
